import { createContext } from "react";
import { LatLng } from "../common/types";

export interface CurrentLocationState {
    location?: LatLng;
    setLocation: (value: LatLng) => void;
}

export const CurrentLocationContext = createContext<CurrentLocationState>({ location: undefined, setLocation: () =>{} });